import { ReactNode } from "react";

import { FormHelperText } from "@mui/material";

import { warningColor } from "assets/colors";

const WarningMessage = ({ warning }: { warning?: string | ReactNode }) => (
  <FormHelperText
    style={{
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: 500,
      fontStyle: "normal",
      lineHeight: "1.25",
      color: warningColor,
    }}
  >
    <span className="material-icons-outlined md-18">warning</span>
    {warning}
  </FormHelperText>
);
export default WarningMessage;
